import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Drawer from "@mui/material/Drawer";
import ViewRenewalPolicy from "./ViewRenewalPolicy";
import FloatLabel from "../../UiComponents/FloatLabel/FloatLabel";
import moment from "moment";
import dayjs from "dayjs";
import { visuallyHidden } from "@mui/utils";
import {
  RemoveRedEyeIcon,
  SearchIcon,
  DownloadIcon,
} from "../../Resources/Icons/icons";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import {
  GetRenewalData,
  GetPolicyFindbyId,
  GetPolicyFileById,
  ReframeEndDateTimeFormat,
} from "../../Service/_index";
import { DatePicker } from "antd";
import { CloudOffIcon } from "../../Resources/Icons/icons";
import { CSVLink } from "react-csv";
import Loader from "../../UiComponents/Loader/Loader";
import FilterBox from "../../UiComponents/FilterBox/FilterBox";
import CustomButton from "../../UiComponents/CommonBUtton/ConfirmBox";
import { Divider, Stack, Badge } from "@mui/material";
import MasterCommonTable from "../../UiComponents/CommonTable/MasterCommonTable";
import { isAction } from "@reduxjs/toolkit";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
const { RangePicker } = DatePicker;
const dateFormat = "DD-MM-YYYY";

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const getClassName = (data) => {
  return data.policyNumber ? "file_link" : null;
};

const headCells = [
  {
    id: "company",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "product",
    placeMent: true,
    disablePadding: false,
    label: "Product",
  },
  {
    id: "policyNumber",
    placeMent: true,
    disablePadding: false,
    label: "Policy Number",
    class: getClassName,
    onClick: true,
  },
  {
    id: "customerName",
    placeMent: true,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "mobileNumber",
    placeMent: true,
    disablePadding: false,
    label: "Mobile",
  },
  {
    id: "registrationNumber",
    placeMent: true,
    disablePadding: false,
    label: "Reg Number",
  },
  {
    id: "odPolicyEndDate",
    placeMent: true,
    disablePadding: false,
    label: "Expiry Date",
  },
  {
    id: "totalPremium",
    placeMent: true,
    disablePadding: false,
    label: "Old Premium",
  },
  {
    id: "email",
    placeMent: true,
    disablePadding: false,
    label: "User",
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const RenewalPolicy = () => {
  // const todayDate = new Date();
  const LastWeekDate = new Date();
  LastWeekDate.setDate(LastWeekDate.getDate() - 7);
  const lastWeekDate = dayjs().subtract(7, "days").startOf("day");
  const todayDate = dayjs().startOf("day");
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [openLoader, setOpenLoader] = useState(false);
  const [renewalPolicy, setRenewalPolicy] = React.useState([]);
  const [selectedStartDate, setSelectedStartDate] = useState(lastWeekDate);
  const [selectedEndDate, setSelectedEndDate] = useState(todayDate);
  const [dateRange, setDateRange] = useState([lastWeekDate, todayDate]);
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchTrigger, setSearchTrigger] = useState(0);
  const [tableConfig, setTableConfig] = useState({
    isAction: true,
    isView: true,
  });
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  // const visibleRows = React.useMemo(
  //   () =>
  //     stableSort(
  //       filter.fn(renewalPolicy),
  //       getComparator(order, orderBy)
  //     )?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
  //   [order, orderBy, page, rowsPerPage, filter, renewalPolicy]
  // );

  // compute active filters count (currently only date range)
  const activeFiltersCount = (() => {
    let count = 0;
    if (dateRange && Array.isArray(dateRange) && dateRange.length === 2)
      count += 1;
    return count;
  })();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - renewalPolicy.length) : 0;

  const lastMonth = moment().subtract(1, "months").startOf("month");
  const today = moment();

  const GetData = () => {
    setOpenLoader(true);
    const Range = { startDate: LastWeekDate, endDate: today };
    GetRenewalData(Range).then((res) => {
      setRenewalPolicy(res.data);
      setOpenLoader(false);
    });
  };

  React.useEffect(() => {
    GetData();
  }, []);

  const GetUnfilteredData = async () => {
    setOpenLoader(true);
    // Fetch data with default one-week date range
    const defaultStartDate = dayjs(lastWeekDate).startOf("day").toDate();
    const defaultEndDate = dayjs(todayDate).endOf("day").toDate();

    const sDate = defaultStartDate.toISOString();
    const eDate = await ReframeEndDateTimeFormat(defaultEndDate);

    const Range = {
      startDate: sDate,
      endDate: eDate,
    };

    GetRenewalData(Range).then((res) => {
      const data = res.data.map((e) => ({
        ...e,
        formatDate: moment(e.tpPolicyEndDate).format("DD/MM/YYYY"),
      }));
      setRenewalPolicy(data);
      setPage(0);
      setOpenLoader(false);
    });
  };

  const UniverselSearch = async (overrideStartDate, overrideEndDate) => {
    setOpenLoader(true);
    // Use override dates if provided (check for undefined/null specifically if needed, but here we assume if passed it's the intent)
    // Note: overrideStartDate could be null if cleared
    const startToUse =
      overrideStartDate !== undefined
        ? overrideStartDate
        : selectedStartDate || lastWeekDate;
    const endToUse =
      overrideEndDate !== undefined
        ? overrideEndDate
        : selectedEndDate || todayDate;

    // Format start date to start of day (00:00:00) as ISO string
    let sDate = "";
    if (startToUse) {
      const start = dayjs(startToUse).startOf("day").toDate();
      sDate = start.toISOString();
    }

    // Format end date to end of day (23:59:59) as ISO string
    let eDate = "";
    if (endToUse) {
      const end = dayjs(endToUse).endOf("day").toDate();
      eDate = await ReframeEndDateTimeFormat(end);
    }

    const Range = {
      startDate: sDate,
      endDate: eDate,
    };

    GetRenewalData(Range).then((res) => {
      const data = res.data.map((e) => ({
        ...e,
        formatDate: moment(e.tpPolicyEndDate).format("DD/MM/YYYY"),
      }));
      setRenewalPolicy(data);
      setPage(0);
      setOpenLoader(false);
    });
  };

  const onSearch = (e) => {
    // console.log("jdsbhsbdjsds",e)
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) =>
            `${el?.companyName},${el?.productId?.product},${el?.policyNumber},${el?.customerName},${el?.mobileNumber},${el?.registrationNumber},${el?.email},${el?.totalPremium}`
              .toLowerCase()
              .includes(target.value.toLowerCase()),
          );
      },
    });
    setSearchText(target.value);
    setPage(0);
  };

  const ViewRenewalPolicyFunction = (row) => {
    GetPolicyFindbyId(row._id).then((res) => {
      setOpenDrawer(true);
      setSelectedData(res?.data);
    });
  };

  const header = [
    { label: "Company Name", key: "company" },
    { label: "Product", key: "product" },
    { label: "Policy Number", key: "policyNumber" },
    { label: "Customer Name", key: "customerName" },
    { label: "Mobile", key: "mobileNumber" },
    { label: "Reg Number", key: "registrationNumber" },
    { label: "Expiry Date", key: "odPolicyEndDate" },
    { label: "Old Premium", key: "totalPremium" },
    { label: "User", key: "user" },
  ];

  const csvFile = {
    filename: "Renewal Policy",
    headers: header,
    data: renewalPolicy,
  };

  const OpenPolicyFile = (row) => {
    setOpenLoader(true);
    GetPolicyFileById(row?._id)
      .then((res) => {
        const pdfUrl = res?.data?.policyFile?.downloadURL;
        return pdfUrl;
      })
      .then((pdfUrl) => {
        setOpenLoader(false);
        // Changes by Arun
        const blobData = base64toBlob(pdfUrl, "application/pdf");
        const blobUrl = URL.createObjectURL(blobData);
        setOpenLoader(false);
        const pdfWindow = window.open("", "_blank");
        pdfWindow?.document?.write(
          // `<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`
          `<embed src="${blobUrl}" width="100%" height="100%" />`,
        );
        // const pdfWindow = window.open("", "_blank");
        // pdfWindow?.document?.write(`<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`);
      });
  };

  // Changes by Arun
  const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  const handleFiltersClick = () => {
    setFiltersVisible((prev) => !prev);
  };

  const filterBoxData = [
    {
      id: 3,
      label: "Select Date",
      setDate: (e) => {
        setDateRange(e);
        if (e && Array.isArray(e) && e.length === 2) {
          const newStart = dayjs(e[0]).startOf("day");
          const newEnd = dayjs(e[1]).startOf("day");
          setSelectedStartDate(newStart);
          setSelectedEndDate(newEnd);
          UniverselSearch(newStart, newEnd);
        } else {
          setSelectedStartDate(null);
          setSelectedEndDate(null);
          UniverselSearch(null, null);
        }
        setSearchTrigger((prev) => prev + 1);
      },
      type: "noDefaultDate",
      defaultValue:
        selectedStartDate && selectedEndDate
          ? [selectedStartDate, selectedEndDate]
          : null,
    },
  ];

  const handleClearAllState = () => {
    setDateRange(null);
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    // Fetch completely unfiltered data
    GetUnfilteredData();
    setSearchText("");
    setSearchTrigger((prev) => prev + 1);
  };

  const handleClearSingleFilter = (filterId) => {
    if (filterId === 3) {
      // Clear date filter
      setDateRange(null);
      setSelectedStartDate(null);
      setSelectedEndDate(null);
      // Fetch completely unfiltered data
      // Fetch completely unfiltered data
      GetUnfilteredData();
      setSearchTrigger((prev) => prev + 1);
    }
  };

  const handleSaveAllFilter = () => {
    UniverselSearch();
    setSearchTrigger((prev) => prev + 1);
  };

  // const formattedData = visibleRows.map((item) => ({
  //   ...item,
  //   // companyName: item?.companyId?.shortName,
  //   // product: item?.productId?.product,
  //   // expiryDate: dayjs(item?.odPolicyEndDate).format("DD/MM/YYYY"),
  // }));
  const filteredData = React.useMemo(
    () => stableSort(filter.fn(renewalPolicy), getComparator(order, orderBy)),
    [order, orderBy, filter, renewalPolicy],
  );

  return (
    <>
      {/* <Box sx={{ flexGrow: 1 }} mt={3}>
        <Grid container className="Master_Header_Container" spacing={2}>
          <Grid item xs={12} sm={3}>
            <Typography className="Master_Header_Heading">
              Renewal Policy
            </Typography>
          </Grid>
          <Grid item xs={12} sm={5.5}></Grid>
          <Grid item xs={12} sm={2}>
            <Input
              focused="false"
              className="w-100 Master_Header_Input"
              id="standard-adornment-password"
              onChange={onSearch}
              disableUnderline={true}
              placeholder="Search"
              startAdornment={
                <InputAdornment position="start">
                  <IconButton aria-label="toggle password visibility">
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </Grid>
          <Grid item xs={12} sm={1.5} className="d-flex justify-content-end">
            <Button
              className="Master_Header_create_Button w-100"
              endIcon={<DownloadIcon />}
            >
              <CSVLink className="Download_Excel_Button" {...csvFile}>
                Download Excel
              </CSVLink>
            </Button>
          </Grid>
        </Grid>
      </Box> */}

      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {/* Filter area is toggled via Filters button (see below) */}
          {/* Table container below filter */}
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems="center"
                className="Master_Card_Sub_Container"
                spacing={2}
              >
                <Grid item xs={12} sm={6} md={6}>
                  <Typography className="Master_Card_Tittle">
                    Renewal Policy
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  className="d-flex justify-content-end"
                  gap={"8px"}
                >
                  <Stack
                    direction="row"
                    spacing={1}
                    sx={{ alignItems: "center" }}
                  >
                    <Button
                      className="Master_Card_Filter_Button"
                      sx={{ width: "102px", height: "40px", gap: "8px" }}
                      startIcon={
                        <Badge
                          badgeContent={activeFiltersCount}
                          sx={{
                            "& .MuiBadge-badge": {
                              right: 5,
                              top: 3,
                              width: "14px",
                              height: "14px",
                              minWidth: "14px",
                              borderRadius: "50%",
                              fontSize: "8.91px",
                              fontWeight: "600",
                              backgroundColor: "#E50000",
                              color: "#fff",
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            },
                          }}
                        >
                          <FilterListIcon sx={{ marginRight: "1.5px" }} />
                        </Badge>
                      }
                      onClick={() => setShowFilter(!showFilter)}
                      size="small"
                      variant="outlined"
                    >
                      Filters
                    </Button>
                    <Button
                      className="Master_Card_Filter_Button"
                      sx={{ width: "102px", height: "40px", gap: "8px" }}
                      startIcon={
                        <CloudDownloadOutlinedIcon
                          sx={{
                            color: "#344054",
                          }}
                        />
                      }
                      size="small"
                      variant="outlined"
                    >
                      <CSVLink
                        style={{ textDecoration: "none", color: "inherit" }}
                        {...csvFile}
                      >
                        Export
                      </CSVLink>
                    </Button>
                  </Stack>
                </Grid>
              </Grid>

              {/* Filter Section */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={true}
                  />
                </Box>
              )}

              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>
              <Grid
                container
                alignItems={"center"}
                justifyContent={"flex-end"}
                margin={1}
              >
                <Grid item xs={12} sm={4} md={3.1}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    onChange={onSearch}
                    disableUnderline={true}
                    placeholder="Search in Access"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
              <MasterCommonTable
                tableConfig={tableConfig}
                data={filteredData}
                columns={headCells}
                handleOnClickBehaviour={OpenPolicyFile}
                handleView={ViewRenewalPolicyFunction}
                loading={openLoader}
                paginationReset={searchText + searchTrigger}
              />
            </Grid>
          </Box>
        </Box>
      </div>
      <Drawer
        open={openDrawer}
        sx={{
          zIndex: 100,
        }}
        anchor="right"
        PaperProps={{
          sx: { width: { xs: "100%", sm: "100%" } },
        }}
      >
        {openDrawer ? (
          <ViewRenewalPolicy
            setOpenDrawer={setOpenDrawer}
            selectedData={selectedData}
          />
        ) : null}
      </Drawer>
      {/* <Loader open={openLoader} /> */}
    </>
  );
};
export default RenewalPolicy;
